<template>
  <v-container fluid>
    <v-card elevation="0">
      <v-form ref="form">
        <v-card-text>
          <v-row no-gutters>
            <v-col
              cols="12" md="5"
            >
              <v-text-field
                class="text-subtitle-1"
                label="ФИО"
                v-model="user.full_name"
                rounded
                required
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col
              class="pl-md-2" cols="12" md="3"
            >
              <v-select
                class="text-subtitle-1"
                label="Пол"
                :value="statement.gender"
                @input="setGender"
                :items="['Женский','Мужской']"
                :rules="[v => !!v || 'Пол не указан']"
                rounded
                required
                outlined
              ></v-select>
            </v-col>
            <v-col
              class="pl-md-2" cols="12" md="4"
            >
              <v-text-field
                rounded
                class="text-subtitle-1"
                label="Телефон"
                :value="statement.curr_phone_statement"
                @input="setCurrPhoneState"
                :rules="[v => (!!v && (/^(\+?7|8)\s?(\(\d{3}\)|\d{3})\s?\d{3}[-\s]?\d{2}[-\s]?\d{2}$/).test(v)) || 'Формат заполнения: +79... или 89...']"
                required
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0" no-gutters>
            <v-col cols="12" md="6">
              <v-text-field
                rounded
                class="text-subtitle-1"
                label="Семейное положение"
                v-model="user.family_status"
                required
                outlined
                readonly
              ></v-text-field>
            </v-col>
            <v-col class="pl-md-2" cols="12" md="6">
              <v-textarea
                rounded
                rows="2"
                class="text-subtitle-1"
                label="Отличительные признак"
                v-model="setPrivilege"
                required
                outlined
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12">
              <v-textarea
                rounded
                rows="2"
                class="text-subtitle-1"
                label="Специальность"
                v-model="user.speciality_name"
                required
                outlined
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row class="mt-0" no-gutters>
            <v-col cols="12">
              <v-textarea
                rounded
                rows="2"
                class="text-subtitle-1"
                label="Факультет"
                v-model="user.facility"
                required
                outlined
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <div class="mx-auto">
          <v-btn
            v-if="Object.keys(show_statement_hostel).length === 0"
            outlined
            rounded
            color="teal darken-1"
            @click="BackTab"
          >
            Назад
          </v-btn>
          <v-btn
            class="ml-2"
            outlined
            rounded
            color="teal darken-1"
            @click="nextTab"
          >
            Далее
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
    import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

    export default {
        name: "PersInfo",
        computed: {
            ...mapState({
                user: state => state.mainHostel.user,
                statement: state => state.interactionStatement.statement_hostel,
                new_phone: state => state.mainHostel.new_phone,
                show_statement_hostel: state => state.interactionStatement.show_statement_hostel,
            }),
            ...mapGetters({
                setPrivilege: 'mainHostel/setPrivilege',
            }),
        },
        mounted() {
            this.setCurrPhoneState(this.user.phone_number)
        },
        methods: {
            ...mapMutations({
                setCurrPhoneState: 'interactionStatement/setCurrPhoneState',
                setGender: 'interactionStatement/setGender',
                visNextTab: 'interactionStatement/visNextTab',
                setActiveTab: 'interactionStatement/setActiveTab',
                initStatement: 'interactionStatement/initStatement',
            }),
            ...mapActions({
              NextTab: 'interactionStatement/NextTab',
              BackTab: 'interactionStatement/BackTab',
              GetPlacesForDepartment: 'placesInDormitories/GetPlacesForDepartment',
            }),
            nextTab() {
                if (this.$refs.form.validate()) {
                    this.NextTab()
                    this.GetPlacesForDepartment(this.user.facility_id).then(() => {
                        this.initStatement();
                    });
                }
            },
            updateForm() {
                if (this.$refs.form.validate()) {
                    this.UpdateStatement().then(() => this.ShowVerifStatement())
                }
            },
        },
    }
</script>

<style scoped>

</style>